// Live Apple-only artwork mode (ec 11-01): the server sends appleArtworkOnly.mode
// (NATIVE | ALL | OFF) on GET /v1/config/lazy-resolve. Polled like nativeMixCover.js
// (at load, then on refocus at most every 5 min) on every platform; the value lands in
// src/shared/appleArtwork.js, which persists it and which the shims and the renderer read.
// On desktop the main process takes it from its own poll of the same endpoint.
import { setAppleArtworkMode } from '../../shared/appleArtwork';

const POLL_MS = 5 * 60 * 1000;

export async function pollAppleArtworkMode() {
    if (typeof window === 'undefined' || !window.electron?.djpal?.getClientConfig) return null;
    try {
        const cfg = await window.electron.djpal.getClientConfig();
        const root = cfg?.data || cfg;
        return setAppleArtworkMode(root?.appleArtworkOnly?.mode);
    } catch (_) { return null; /* keep the last-known mode; the next poll retries */ }
}

if (typeof window !== 'undefined') {
    // desktop: getClientConfig reads the main process's cache, which its own lazy-resolve poll may
    // not have filled yet at load — ask again shortly while no mode has arrived
    pollAppleArtworkMode().then((m) => { if (!m) setTimeout(() => pollAppleArtworkMode().then((m2) => { if (!m2) setTimeout(pollAppleArtworkMode, 60000); }), 15000); });
    if (typeof document !== 'undefined') {
        let lastPollAt = Date.now();
        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState !== 'visible') return;
            const now = Date.now();
            if (now - lastPollAt < POLL_MS) return;
            lastPollAt = now;
            pollAppleArtworkMode();
        });
    }
}
